module.exports = __webpack_public_path__ + "static/media/person.5ea89a32.svg";